import { render } from "./Intro.vue?vue&type=template&id=23456972&ts=true"
import script from "./Intro.vue?vue&type=script&lang=ts"
export * from "./Intro.vue?vue&type=script&lang=ts"

import "./Intro.vue?vue&type=style&index=0&id=23456972&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__